import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { URL_GLOBAL, URL_WEB } from 'src/environments/environment';
import { AuthService } from "../vos/auth.service";

@Injectable({
  providedIn: 'root'
})
export class MedicaoService {
  constructor(private http: HttpClient, private authService: AuthService) { }

  gerarXML(cliente_id, contract_id, data_inicio, data_fim): Observable<any[]> {
    console.log(this.authService.userToken())
    return this.http.post<any[]>(`${URL_GLOBAL}/tiss/gerar-xml{data_fim}/${cliente_id}/${contract_id}?data_inicio=${data_inicio}&data_fim=${data_fim}`, { headers: this.authService.userToken() });
  }


  getAllMedicoes(params): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/medicoes?periodo=${params.periodo}&cliente_id=${params.cliente_id ? params.cliente_id : ''}`, { headers: this.authService.userToken() });
  }

  save(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/medicoes`, data, { headers: this.authService.userToken() });
  }

  find(id: any): Observable<any> {
    return this.http.get(`${URL_GLOBAL}/medicoes/${id}`, { headers: this.authService.userToken() });
  }

  update(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/medicoes/${id}`, data, { headers: this.authService.userToken() });
  }

  destroy(id: any): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/medicoes/${id}`, { headers: this.authService.userToken() });
  }
  gerarTiss(cliente_id, id): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/tiss/gerarXml/${cliente_id}`, { id: id }, { headers: this.authService.userToken() });
  }

  gerarXMLs(cliente_id, ids) {
    return this.http.post<any>(`${URL_GLOBAL}/tiss/gerar-xml-medicao/${cliente_id}`, { medicoes: ids }, { headers: this.authService.userToken() });
  }

  downloadXml(filename): Observable<any> {
    return this.http.get(`${URL_GLOBAL}/tiss/downloadXml`, {
      responseType: 'blob',
      headers: this.authService.userToken(),
      params: { filename: filename }
    },)
  }
  atualizarTiss(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/tiss/editarXml/${id}`, data, { headers: this.authService.userToken() });
  }

  // END POINT
  getAllMedicoesNew(params): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/new-medicoes?periodo=${params.periodo}&cliente_id=${params.cliente_id ? params.cliente_id : ''}&tipo=${params.tipo ? params.tipo : ''}`, { headers: this.authService.userToken() });
  }

  saveNew(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/new-medicoes`, data, { headers: this.authService.userToken() });
  }

  findNew(id: any): Observable<any> {
    return this.http.get(`${URL_GLOBAL}/new-medicoes/${id}`, { headers: this.authService.userToken() });
  }

  updateNew(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/new-medicoes/${id}`, data, { headers: this.authService.userToken() });
  }

  destroyNew(id: any): Observable<any> {
    return this.http.delete<any>(`${URL_GLOBAL}/new-medicoes/${id}`, { headers: this.authService.userToken() });
  }

  // Rotas de alteração para o novo funcionamento
  buscaMedicoesOS(): Observable<any> {
    return this.http.get<any>(`${URL_GLOBAL}/buscamedicoes`, { headers: this.authService.userToken() });
  }
  atualizaMedicoesOS(data: any): Observable<any> {
    return this.http.post<any>(`${URL_GLOBAL}/atualizamedicoes`, data, { headers: this.authService.userToken() });
  }

  //claim-management
  changeClaim(data): Observable<any> {
    return this.http.put<any>(`${URL_WEB}/claim/change-claim`, data, { headers: this.authService.userToken() });
  }

  motivesClaim(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_WEB}/claim/motives-claim`, { headers: this.authService.userToken() });
  }

  storeOrUpdateClaim(data: any): Observable<any> {
    return this.http.post<any>(`${URL_WEB}/claim/store-update-claim`, data, { headers: this.authService.userToken() });
  }

  resendClaim(data: any): Observable<any> {
    return this.http.post<any>(`${URL_WEB}/claim/resend-claim`, data, { headers: this.authService.userToken() });
  }

  approveClaim(id): Observable<any> {
    return this.http.put<any>(`${URL_WEB}/claim/approve-claim/${id}`, {}, { headers: this.authService.userToken() });
  }

  getClaims(params): Observable<any> {
    return this.http.get<any>(`${URL_WEB}/claim/claims?periodo=${params.periodo}&cliente_id=${params.cliente_id ? params.cliente_id : ''}`, { headers: this.authService.userToken() });
  }
  //
}
